import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { generateGuidePath, ROOM_TYPES, PROBLEMS } from '@/data/seoVariables';

const POPULAR_GUIDES = [
  { size: 200, roomType: 'bedroom', problem: 'allergies' },
  { size: 300, roomType: 'living-room', problem: 'pet-dander' },
  { size: 150, roomType: 'nursery', problem: 'dust-mites' },
  { size: 400, roomType: 'master-bedroom', problem: 'allergies' },
  { size: 300, roomType: 'home-office', problem: 'general' },
  { size: 500, roomType: 'basement', problem: 'mold' },
  { size: 250, roomType: 'bedroom', problem: 'wildfire-smoke' },
  { size: 200, roomType: 'kitchen', problem: 'cooking-odors' },
  { size: 350, roomType: 'living-room', problem: 'allergies' },
  { size: 150, roomType: 'home-office', problem: 'dust-mites' },
  { size: 600, roomType: 'living-room', problem: 'wildfire-smoke' },
  { size: 300, roomType: 'studio', problem: 'pet-dander' },
];

export function PopularGuides() {
  const guides = POPULAR_GUIDES.map(g => {
    const roomType = ROOM_TYPES.find(r => r.slug === g.roomType)!;
    const problem = PROBLEMS.find(p => p.slug === g.problem)!;
    const Icon = problem.icon;
    return { ...g, roomType, problem, Icon, path: generateGuidePath(g.size, g.roomType, g.problem) };
  });

  return (
    <section className="py-12 section-divider">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-2xl font-bold text-foreground">Popular Air Purifier Guides</h2>
            <p className="text-muted-foreground mt-1">
              Find the right CADR for your specific room and concern
            </p>
          </div>
          <Link
            to="/guides"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary hover:underline"
          >
            View all guides
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {guides.map((guide, i) => (
            <Link key={i} to={guide.path} className="group">
              <Card className="h-full transition-all duration-200 hover:border-primary/50 hover:shadow-md">
                <CardContent className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <guide.Icon className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
                    <Badge variant="outline" className="text-xs">{guide.problem.name}</Badge>
                  </div>
                  <p className="font-medium text-sm group-hover:text-primary transition-colors">
                    {guide.size} sq ft {guide.roomType.name}
                  </p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        <Link
          to="/guides"
          className="sm:hidden flex items-center justify-center gap-1 mt-4 text-sm font-medium text-primary hover:underline"
        >
          View all guides
          <ArrowRight className="h-4 w-4" />
        </Link>
      </motion.div>
    </section>
  );
}
